const textToSpecifics = (textNode) => {
  const { text, ...specifics } = textNode;
  return specifics;
};
export {
  textToSpecifics
};
//# sourceMappingURL=textToSpecifics.js.map
